import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { useTourismData } from "../../context/TourismContext";
import { getImageUrl } from "../../services/api";

function DestinationThree() {
    // Get tourism data and actions from context
    const { airTicket, fetchAirTicketDestinations } = useTourismData();
    const { destinations } = airTicket;

    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchAirTicketDestinations();
            } catch (error) {
                console.error('Error fetching AirTicket destinations:', error);
            }
        };
        
        fetchData();
    }, [fetchAirTicketDestinations]);

    // Fallback static destinations
    const fallbackDestinations = [
        { id: 1, name: "Dubai, UAE", image: "/assets/img/destination/destination_3_1.jpg", short_description: "Premium flights available", starting_price: 299 },
        { id: 2, name: "Japan", image: "/assets/img/destination/destination_3_2.jpg", short_description: "Explore the Land of Rising Sun", starting_price: 599 },
        { id: 3, name: "Switzerland", image: "/assets/img/destination/destination_3_3.jpg", short_description: "Alpine adventures await", starting_price: 799 },
        { id: 4, name: "Brazil", image: "/assets/img/destination/destination_3_4.jpg", short_description: "Experience vibrant culture", starting_price: 499 },
    ];

    // Use API data if available, otherwise use fallback
    const displayDestinations = destinations && destinations.length > 0 ? destinations : fallbackDestinations;

    return (
        <section
            className="position-relative overflow-hidden space"
            id="destination-sec"
            style={{ backgroundImage: "url(/assets/img/bg/line-pattern3.png)" }}
        >
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-lg-6">
                        <div className="title-area">
                            <span className="sub-title">Top Destination</span>
                            <h2 className="sec-title">Popular Destination</h2>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <h2 className="destination-title">
                            <span className="counter-number">850</span>+&nbsp;Destinations
                        </h2>
                        <p className="sec-text mb-30">
                            One of the most well-liked travel companies for people looking to
                            experience adventure and see the world is Tourm.
                        </p>
                    </div>
                </div>

                {/* Swiper Slider */}
                <Swiper
                    modules={[Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    breakpoints={{
                        576: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        992: { slidesPerView: 2 },
                        1200: { slidesPerView: 3 },
                        1300: { slidesPerView: 4 },
                    }}
                    autoplay={{ delay: 3000 }}
                    className="th-slider has-shadow"
                >
                    {displayDestinations.map((item) => (
                        <SwiperSlide key={item.id}>
                            <div className="destination-item th-ani">
                                <div className="destination-item_img global-img">
                                    <img 
                                        src={getImageUrl(item.main_image_url) || item.image || '/assets/img/destination/destination_3_1.jpg'} 
                                        alt={item.name} 
                                        onError={(e) => {
                                            e.target.src = '/assets/img/destination/destination_3_1.jpg';
                                        }}
                                    />
                                </div>
                                <div className="destination-content">
                                    <h3 className="box-title">
                                        <Link to={`/destination/${item.slug || item.id}`}>{item.name}</Link>
                                    </h3>
                                    <p className="destination-text">
                                        {item.airport_code ? `${item.airport_code} Airport` : '25 Listing'}
                                    </p>
                                    <Link to="/contact" className="th-btn style4 th-icon">
                                        {item.starting_price ? `From $${item.starting_price}` : 'Book Now'}
                                    </Link>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="destination-btn text-center mt-60">
                    <Link to="/destination" className="th-btn style3 th-icon">
                        View All
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default DestinationThree;
